import APICall from "../utils/APICall";

export default class TransactionUtilitiesServices {
  //  transaction list
  static listTransactionUtilities = async (
    pageSize,
    pageIndex,
    search,
    availabilityStatus,
    showDeleted = false
  ) => {
    let url = `/api/TransactionUtilities/bank-availability/status?pageIndex=${pageIndex}&pageSize=${pageSize}`;

    if (search) url += `&search=${search}`;
    if (availabilityStatus) url += `&availabilityStatus=${availabilityStatus}`;
    if (showDeleted) url += `&includeDeleted=false`;

    return await APICall(url, "GET");
  };

  // Create new bank availability status
  static createBankAvailability = async (data) => {
    let url = `/api/TransactionUtilities/bank-availability/create`;
    return await APICall(url, "POST", data);
  };

  // Update bank availability
  static updateBankAvailability = async (id, data) => {
    let url = `/api/TransactionUtilities/bank-availability/update/${id}`;
    return await APICall(url, "PATCH", data);
  };

  // Toggle bank availability status
  static toggleBankAvailability = async (id, data) => {
    let url = `/api/TransactionUtilities/bank-availability/toggle-availability-status/${id}`;
    return await APICall(url, "PATCH", data);
  };

  // Delete bank availability
  static deleteBankAvailability = async (id, data) => {
    let url = `/api/TransactionUtilities/bank-availability/delete/${id}`;
    return await APICall(url, "DELETE", data);
  };

  //Fraudulent Account
  static listFraudulentAccount = async (pageSize, pageIndex, search) => {
    let url = `/api/TransactionUtilities/fraudulent-account/fetch-all?pageIndex=${pageIndex}&pageSize=${pageSize}`;
    if (search) url += `&search=${search}`;
    return await APICall(url, "GET");
  };

  // Create new fraudulent account
  static reportFraudulentAccount = async (data) => {
    const url = `/api/TransactionUtilities/fraudulent-account/report`;
    return await APICall(url, "POST", data);
  };

  // Update fraudulent account
  static toggleFlagStatus = async (accountNumber, flagStatus, adminReason, bankCode) => {
    const url = `/api/TransactionUtilities/fraudulent-account/toggle-flag-status?accountNumber=${accountNumber}&flagStatus=${flagStatus} &adminReason=${adminReason}&bankCode=${bankCode}`;
    return await APICall(url, "PATCH");
  };
}
